<div style="height: 100%; width: 100%;">
  @if (loading) {
    <bracelit-preloader [absoluteCentered]="true">
    </bracelit-preloader>
  }
  <form [formGroup]="myForm" class="cart-container" style="display: flex; flex-direction: row; flex-wrap: wrap;">
    <div class="payments-card-container" style="display: flex; align-items: center; justify-content: center;">
      <mat-card class="bracelit-card-2 white-opacity-background payments-card" style="display: flex; flex-direction: row; flex-wrap: wrap;">
        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="500ms" style="width: 100%;">
          <mat-tab>
            <ng-template mat-tab-label>
              <span class="bold-16px-center-primary">{{ 'showContacts.contact' | translate }}</span>
            </ng-template>
            @if (!errormessage) {
              <div class="tab-content-container"
              style="width: 100%; display: flex; flex-direction: column; flex-wrap: wrap; display: flex; align-items: flex-start; justify-content: center;">
                <div>
                  <div id="recharge-button" class="bracels-input-width input-primary">
                    <mat-label class="light-16px-left-primary">{{ 'showContacts.name' | translate }}: </mat-label>
                    <label>{{name}}</label>
                  </div>

                  <div id="recharge-button" class="bracels-input-width input-primary">
                    <mat-label class="light-16px-left-primary">{{ 'showContacts.surname' | translate }}: </mat-label>
                    <label>{{surname}}</label>
                  </div>

                  <div id="recharge-button" class="bracels-input-width input-primary">
                    <mat-label class="light-16px-left-primary">{{ 'showContacts.email' | translate }}: </mat-label>
                    <label>{{email}}</label>
                  </div>

                  <div id="recharge-button" class="bracels-input-width input-primary">
                    <mat-label class="light-16px-left-primary">{{ 'showContacts.phone' | translate }}: </mat-label>
                    <label>{{phone}}</label>
                  </div>
                  <div id="recharge-button" class="bracels-input-width input-primary">
                    <bee-form [beeFormGroup]="myForm"
                              [method]="'post'"
                              [toastMessage]="'Usuario importado con éxito'"
                              [errorMessage]="'Error al importado usuario, inténtalo de nuevo'"
                              [saveButtonText]="'GUARDAR CAMBIOS'"
                              [backEnabled]="false"
                              [requiredSign]="false"
                              [showButtons]="false"
                              [layoutGap]="'0'"
                              (postSubmitFunction)="saveComment()">
                    @if (hasComment) {
                      <div style="padding-top: 10%">
                      <bee-form-item style="width: 100%;"
                                [type]="'text'"
                                [id]="'user-mail-subject'"
                                [label]="''"
                                [placeholder]="comment"
                                [appearance]="'outline'"
                                [beeFormControl]="myForm.controls['comment']"></bee-form-item>
                      </div>
                    }
                    </bee-form>
                  </div>
                </div>
              </div>
            }
            @if (!errormessage) {
              <div style="width: 100%; display: flex; flex-direction: row; display: flex; align-items: center; justify-content: center; padding-bottom: 10px">
                  <button class="primary-background regular-16px-center-white"
                          (click)="saveComment()">{{ 'showContacts.save' | translate }}</button>
              </div>
            }
            @if (errormessage) {
              <div id ="recharge-tex" class="light-16px-left-primary" style="display: flex; flex-direction: column; display: flex; align-items: center; justify-content: center;">{{texto}}</div>
            }
          </mat-tab>
        </mat-tab-group>
      </mat-card>
    </div>
  </form>
</div>
